// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v6.33.4
// source: transcript_corrections.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "transcript_corrections";

/** Main proto definition */
export interface TranscriptCorrections {
  corrections: TranscriptCorrection[];
}

export interface TranscriptCorrection {
  id: string;
  name: string;
  description: string;
  regularExpressions: RegularExpression[];
  createdBy: string;
  createdAt: Date | undefined;
  updatedBy: string;
  updatedAt: Date | undefined;
}

export interface RegularExpression {
  id: string;
  regularExpression: string;
  replacement: string;
  replacementType: string;
}

/** commands */
export interface TranscriptCorrectionsCreateTranscriptCorrections {
  id: string;
  name: string;
  description?: string | undefined;
  regularExpressions: RegularExpression[];
}

export interface TranscriptCorrectionsUpdateTranscriptCorrections {
  data?: TranscriptCorrectionsUpdateData | undefined;
}

export interface TranscriptCorrectionsUpdateData {
  corrections: TranscriptCorrection[];
}

export interface TranscriptCorrectionsDeleteTranscriptCorrections {
  transcriptCorrectionsId: string;
}

function createBaseTranscriptCorrections(): TranscriptCorrections {
  return { corrections: [] };
}

export const TranscriptCorrections: MessageFns<TranscriptCorrections> = {
  encode(message: TranscriptCorrections, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.corrections) {
      TranscriptCorrection.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranscriptCorrections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranscriptCorrections();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.corrections.push(TranscriptCorrection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranscriptCorrections {
    return {
      corrections: globalThis.Array.isArray(object?.corrections)
        ? object.corrections.map((e: any) => TranscriptCorrection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TranscriptCorrections): unknown {
    const obj: any = {};
    if (message.corrections?.length) {
      obj.corrections = message.corrections.map((e) => TranscriptCorrection.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<TranscriptCorrections>): TranscriptCorrections {
    return TranscriptCorrections.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranscriptCorrections>): TranscriptCorrections {
    const message = createBaseTranscriptCorrections();
    message.corrections = object.corrections?.map((e) => TranscriptCorrection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTranscriptCorrection(): TranscriptCorrection {
  return {
    id: "",
    name: "",
    description: "",
    regularExpressions: [],
    createdBy: "",
    createdAt: undefined,
    updatedBy: "",
    updatedAt: undefined,
  };
}

export const TranscriptCorrection: MessageFns<TranscriptCorrection> = {
  encode(message: TranscriptCorrection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.regularExpressions) {
      RegularExpression.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranscriptCorrection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranscriptCorrection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.regularExpressions.push(RegularExpression.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranscriptCorrection {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      regularExpressions: globalThis.Array.isArray(object?.regularExpressions)
        ? object.regularExpressions.map((e: any) => RegularExpression.fromJSON(e))
        : globalThis.Array.isArray(object?.regular_expressions)
        ? object.regular_expressions.map((e: any) => RegularExpression.fromJSON(e))
        : [],
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: TranscriptCorrection): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.regularExpressions?.length) {
      obj.regularExpressions = message.regularExpressions.map((e) => RegularExpression.toJSON(e));
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<TranscriptCorrection>): TranscriptCorrection {
    return TranscriptCorrection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranscriptCorrection>): TranscriptCorrection {
    const message = createBaseTranscriptCorrection();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.regularExpressions = object.regularExpressions?.map((e) => RegularExpression.fromPartial(e)) || [];
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseRegularExpression(): RegularExpression {
  return { id: "", regularExpression: "", replacement: "", replacementType: "" };
}

export const RegularExpression: MessageFns<RegularExpression> = {
  encode(message: RegularExpression, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.regularExpression !== "") {
      writer.uint32(18).string(message.regularExpression);
    }
    if (message.replacement !== "") {
      writer.uint32(26).string(message.replacement);
    }
    if (message.replacementType !== "") {
      writer.uint32(34).string(message.replacementType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegularExpression {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegularExpression();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.regularExpression = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.replacement = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.replacementType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegularExpression {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      regularExpression: isSet(object.regularExpression)
        ? globalThis.String(object.regularExpression)
        : isSet(object.regular_expression)
        ? globalThis.String(object.regular_expression)
        : "",
      replacement: isSet(object.replacement) ? globalThis.String(object.replacement) : "",
      replacementType: isSet(object.replacementType)
        ? globalThis.String(object.replacementType)
        : isSet(object.replacement_type)
        ? globalThis.String(object.replacement_type)
        : "",
    };
  },

  toJSON(message: RegularExpression): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.regularExpression !== "") {
      obj.regularExpression = message.regularExpression;
    }
    if (message.replacement !== "") {
      obj.replacement = message.replacement;
    }
    if (message.replacementType !== "") {
      obj.replacementType = message.replacementType;
    }
    return obj;
  },

  create(base?: DeepPartial<RegularExpression>): RegularExpression {
    return RegularExpression.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RegularExpression>): RegularExpression {
    const message = createBaseRegularExpression();
    message.id = object.id ?? "";
    message.regularExpression = object.regularExpression ?? "";
    message.replacement = object.replacement ?? "";
    message.replacementType = object.replacementType ?? "";
    return message;
  },
};

function createBaseTranscriptCorrectionsCreateTranscriptCorrections(): TranscriptCorrectionsCreateTranscriptCorrections {
  return { id: "", name: "", description: undefined, regularExpressions: [] };
}

export const TranscriptCorrectionsCreateTranscriptCorrections: MessageFns<
  TranscriptCorrectionsCreateTranscriptCorrections
> = {
  encode(
    message: TranscriptCorrectionsCreateTranscriptCorrections,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.regularExpressions) {
      RegularExpression.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranscriptCorrectionsCreateTranscriptCorrections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranscriptCorrectionsCreateTranscriptCorrections();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.regularExpressions.push(RegularExpression.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranscriptCorrectionsCreateTranscriptCorrections {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      regularExpressions: globalThis.Array.isArray(object?.regularExpressions)
        ? object.regularExpressions.map((e: any) => RegularExpression.fromJSON(e))
        : globalThis.Array.isArray(object?.regular_expressions)
        ? object.regular_expressions.map((e: any) => RegularExpression.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TranscriptCorrectionsCreateTranscriptCorrections): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.regularExpressions?.length) {
      obj.regularExpressions = message.regularExpressions.map((e) => RegularExpression.toJSON(e));
    }
    return obj;
  },

  create(
    base?: DeepPartial<TranscriptCorrectionsCreateTranscriptCorrections>,
  ): TranscriptCorrectionsCreateTranscriptCorrections {
    return TranscriptCorrectionsCreateTranscriptCorrections.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TranscriptCorrectionsCreateTranscriptCorrections>,
  ): TranscriptCorrectionsCreateTranscriptCorrections {
    const message = createBaseTranscriptCorrectionsCreateTranscriptCorrections();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? undefined;
    message.regularExpressions = object.regularExpressions?.map((e) => RegularExpression.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTranscriptCorrectionsUpdateTranscriptCorrections(): TranscriptCorrectionsUpdateTranscriptCorrections {
  return { data: undefined };
}

export const TranscriptCorrectionsUpdateTranscriptCorrections: MessageFns<
  TranscriptCorrectionsUpdateTranscriptCorrections
> = {
  encode(
    message: TranscriptCorrectionsUpdateTranscriptCorrections,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.data !== undefined) {
      TranscriptCorrectionsUpdateData.encode(message.data, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranscriptCorrectionsUpdateTranscriptCorrections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranscriptCorrectionsUpdateTranscriptCorrections();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = TranscriptCorrectionsUpdateData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranscriptCorrectionsUpdateTranscriptCorrections {
    return { data: isSet(object.data) ? TranscriptCorrectionsUpdateData.fromJSON(object.data) : undefined };
  },

  toJSON(message: TranscriptCorrectionsUpdateTranscriptCorrections): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = TranscriptCorrectionsUpdateData.toJSON(message.data);
    }
    return obj;
  },

  create(
    base?: DeepPartial<TranscriptCorrectionsUpdateTranscriptCorrections>,
  ): TranscriptCorrectionsUpdateTranscriptCorrections {
    return TranscriptCorrectionsUpdateTranscriptCorrections.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TranscriptCorrectionsUpdateTranscriptCorrections>,
  ): TranscriptCorrectionsUpdateTranscriptCorrections {
    const message = createBaseTranscriptCorrectionsUpdateTranscriptCorrections();
    message.data = (object.data !== undefined && object.data !== null)
      ? TranscriptCorrectionsUpdateData.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseTranscriptCorrectionsUpdateData(): TranscriptCorrectionsUpdateData {
  return { corrections: [] };
}

export const TranscriptCorrectionsUpdateData: MessageFns<TranscriptCorrectionsUpdateData> = {
  encode(message: TranscriptCorrectionsUpdateData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.corrections) {
      TranscriptCorrection.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranscriptCorrectionsUpdateData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranscriptCorrectionsUpdateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.corrections.push(TranscriptCorrection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranscriptCorrectionsUpdateData {
    return {
      corrections: globalThis.Array.isArray(object?.corrections)
        ? object.corrections.map((e: any) => TranscriptCorrection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TranscriptCorrectionsUpdateData): unknown {
    const obj: any = {};
    if (message.corrections?.length) {
      obj.corrections = message.corrections.map((e) => TranscriptCorrection.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<TranscriptCorrectionsUpdateData>): TranscriptCorrectionsUpdateData {
    return TranscriptCorrectionsUpdateData.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranscriptCorrectionsUpdateData>): TranscriptCorrectionsUpdateData {
    const message = createBaseTranscriptCorrectionsUpdateData();
    message.corrections = object.corrections?.map((e) => TranscriptCorrection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTranscriptCorrectionsDeleteTranscriptCorrections(): TranscriptCorrectionsDeleteTranscriptCorrections {
  return { transcriptCorrectionsId: "" };
}

export const TranscriptCorrectionsDeleteTranscriptCorrections: MessageFns<
  TranscriptCorrectionsDeleteTranscriptCorrections
> = {
  encode(
    message: TranscriptCorrectionsDeleteTranscriptCorrections,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.transcriptCorrectionsId !== "") {
      writer.uint32(10).string(message.transcriptCorrectionsId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranscriptCorrectionsDeleteTranscriptCorrections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranscriptCorrectionsDeleteTranscriptCorrections();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.transcriptCorrectionsId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranscriptCorrectionsDeleteTranscriptCorrections {
    return {
      transcriptCorrectionsId: isSet(object.transcriptCorrectionsId)
        ? globalThis.String(object.transcriptCorrectionsId)
        : isSet(object.transcript_corrections_id)
        ? globalThis.String(object.transcript_corrections_id)
        : "",
    };
  },

  toJSON(message: TranscriptCorrectionsDeleteTranscriptCorrections): unknown {
    const obj: any = {};
    if (message.transcriptCorrectionsId !== "") {
      obj.transcriptCorrectionsId = message.transcriptCorrectionsId;
    }
    return obj;
  },

  create(
    base?: DeepPartial<TranscriptCorrectionsDeleteTranscriptCorrections>,
  ): TranscriptCorrectionsDeleteTranscriptCorrections {
    return TranscriptCorrectionsDeleteTranscriptCorrections.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TranscriptCorrectionsDeleteTranscriptCorrections>,
  ): TranscriptCorrectionsDeleteTranscriptCorrections {
    const message = createBaseTranscriptCorrectionsDeleteTranscriptCorrections();
    message.transcriptCorrectionsId = object.transcriptCorrectionsId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
